// Only the verified public film belongs here. No player or tracking loads until clicked.
export const PRODUCT_VIDEO_URL = 'https://www.youtube.com/watch?v=WkvHKYmke3M';
